
export const BUTTON_TYPE = {
  ICON: "icon",
  TEXT: "text",
  TEXT_AND_ICON: "textAndIcon",
};

export const BUTTON_ALIGN = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
};

export const BUTTON_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const BUTTON_PROP = {
  ACCENT_COLOR: "accentColor",
  BACKGROUND_COLOR: "backgroundColor",
  BORDER: "border",
  LABEL_COLOR: "labelColor",
  ALIGN: "align",
  CORNERS: "corners",
  TYPE: "type",
  LABEL: "label",
  SIZE: "size",
  WIDTH: "width",
  ICON: "icon",
  ICON_POSITION: "iconPosition",
  NEW_TAB: "newTab",
  URL: "url",
  STYLE: "style",
  HOVER: "hover",
  STYLE_VARIANT: "styleVariant",
};

export const LIBRARY_SERVICE_ACTION = {
  create: "createNewButton",
  edit: "editButton",
};

export const BUTTON_FALLBACK_BG_COLOR = "#fff";
export const BUTTON_FALLBACK_COLOR = "#000";
export const BACKGROUND_TRANSPARENT = "transparent";
export const DEFAULT_STYLE = "outline";
export const DEFAULT_WIDTH = 46;
export const DEFAULT_WIDTH_TEXT = 111;
export const DEFAULT_WIDTH_TEXT_AND_ICON = 135;
export const MAX_WIDTH = 600;
export const DEFAULT_HOVER = true;
